import { render } from "./RegisterView.vue?vue&type=template&id=11cbd783&scoped=true&ts=true"
import script from "./RegisterView.vue?vue&type=script&lang=ts"
export * from "./RegisterView.vue?vue&type=script&lang=ts"

import "./RegisterView.scss?vue&type=style&index=0&id=11cbd783&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11cbd783"]])

export default __exports__